import { ButtonHTMLAttributes, FC } from 'react';
import { Container, Content, Icon, Label } from './ProfileButton.styles';

interface ProfileButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	label: string;
	icon?: JSX.Element;
	active?: boolean;
}

const ProfileButton: FC<ProfileButtonProps> = ({ label, icon, active = false, onClick }) => {
	return (
		<Container $active={active} onClick={onClick}>
			<Content>
				<Icon>{icon}</Icon>
				<Label>{label}</Label>
			</Content>
		</Container>
	);
};

export default ProfileButton;
